import { Component, OnInit, EventEmitter, Output, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-anno-filter',
  templateUrl: './anno-filter.component.html',
  styleUrls: ['./anno-filter.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AnnoFilterComponent),
      multi: true
    }
  ]
})
export class AnnoFilterComponent  implements OnInit {
  anno: number;
  @Output() confirmNotify: EventEmitter<any> = new EventEmitter<any>();
  @Output() quitNotify: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  confirm() {
    this.confirmNotify.emit({ q: { field: 'anno', value: this.anno }, t: { k: 'ANNO', v: this.anno, l: 'anno' } });
  }

  enter(e) {
    if (e) e.preventDefault();

    if (this.anno) {
      this.confirm()
    }
  }

  quit() {
    this.quitNotify.emit();
  }

  ngOnInit() {
  }

  private propagateChange = (_: any) => { };

  public writeValue(s: number) {
    this.anno = s;
  }

  public registerOnChange(fn: any) {
    this.propagateChange = fn;
  }

  public registerOnTouched() { }
}



// WEBPACK FOOTER //
// ./src/app/helpers/filters/anno-filter/anno-filter.component.ts